import { useState, useEffect, useRef, Fragment, memo, useMemo } from "react";
import style from "./../index.module.scss";
import styleUi from "./EditPotList.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Checkbox from '@mui/material/Checkbox';
import AppConfig from '../../AppConfig';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Folder from "./../../comm/global/components/Folder";

const EditPotList = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const [folders, set_folders] = useState([
        { label: "適合新手的路線", list: [] },
    ]);
    const scrollableRef = useRef(null);
    const contentRef = useRef(null);
    const maskRef = useRef(null);

    useEffect(() => {
        console.log("EditPotList");
        setInProp(true);
        if (scrollableRef.current && maskRef.current) {
            const h = scrollableRef.current.clientHeight;
            maskRef.current.style.minHeight = `${h}px`;
            scrollableRef.current.style.maxHeight = `${h}px`;
            scrollableRef.current.scrollTop = h;
        }
    }, [])
    useEffect(() => {
        updateHeight()
    }, [folders])

    function updateHeight() {
        if (scrollableRef.current && maskRef.current) {
            const h = contentRef.current.clientHeight;
            maskRef.current.style.minHeight = `${h}px`;
            scrollableRef.current.style.maxHeight = `${h}px`;
            scrollableRef.current.scrollTop = h;
        }
    }
    function releseHand(e) {
        if (scrollableRef.current.scrollTop < scrollableRef.current.clientHeight*.9) {
            scrollableRef.current.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
            setTimeout(() => {
                setInProp(false);
            }, 500);
        }
        else
            scrollableRef.current.scrollTo({
                top: scrollableRef.current.clientHeight,
                left: 0,
                behavior: "smooth",
            })
    }

    return (
        <div className={style.modalBottom} style={{ backgroundColor: "#00000055", overflow: "hidden" }}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "EditPotList"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app} ref={scrollableRef} onTouchEnd={e => { releseHand(e) }} onMouseUp={e => { releseHand(e) }} onScroll={e => {
                                if (e.target.scrollTop === 0)
                                    setInProp(false);
                            }}>
                                <div className={styleUi.mask} ref={maskRef}>
                                </div>
                                <div className={styleUi.content} ref={contentRef} >
                                    <div className={styleUi.bg}>
                                        <div className={styleUi.bar}>
                                        </div>
                                    </div>
                                    <div className={styleUi.view}>
                                        <div className={styleUi.list}>
                                            <div className={styleUi.option} onClick={e => {
                                                setInProp(false);
                                                addModalType({
                                                    cls: "AlertCustom", arg: {
                                                        title: "刪除此清單？",
                                                        desc: "刪除此清單後，將無法復原。",
                                                        options: [
                                                            {
                                                                label: "刪除", cb: () => {
                                                                    setInProp(false);
                                                                    arg.cb("del");
                                                                }
                                                            },
                                                            {
                                                                label: "取消", cb: () => {

                                                                }
                                                            },
                                                        ],
                                                    }
                                                })
                                            }}>
                                                <DeleteOutlineIcon />
                                                <span>刪除清單</span>
                                            </div>
                                            <div className={styleUi.option} onClick={e => {
                                                arg.cb("edit");
                                                setInProp(false);
                                            }}>
                                                <EditIcon />
                                                <span>編輯清單</span>
                                            </div>
                                            <button className={allStyle.btnGray2} onClick={e => {
                                                arg.cb("cancel");
                                                setInProp(false);
                                            }}>
                                                取消
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition >
        </div >
    );
}

export default memo(EditPotList);